import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIList from 'UIComponents/list/UIList';
import { getApplicationDomain } from '../constants/apiEnvironments';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { devices } from '../styles/viewports.styles';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
const StyledUIList = styled(UIList).withConfig({
  displayName: "PendingEmailOAuthError__StyledUIList",
  componentId: "sc-1eco2ky-0"
})(["list-style-position:inside;padding-inline-start:0;"]);
const StyledUICardWrapper = styled(UICardWrapper).withConfig({
  displayName: "PendingEmailOAuthError__StyledUICardWrapper",
  componentId: "sc-1eco2ky-1"
})(["@media ", "{max-width:31.25rem;}"], devices.desktop);

const PendingEmailOAuthError = () => {
  const {
    redirectToLogin
  } = useLoginRedirect();
  const errorKey = ErrorKey.OAuthPendingEmailVerification;

  const onClick = () => {
    redirectToLogin({
      redirectUrl: `${getApplicationDomain()}/user-preferences/security`
    });
  };

  const renderContent = () => {
    return /*#__PURE__*/_jsxs(StyledUICardWrapper, {
      className: "m-all-auto m-y-5 p-all-5 text-left",
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `error.${errorKey}.howToFix`
        })
      }), /*#__PURE__*/_jsxs(StyledUIList, {
        ordered: true,
        styled: true,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `error.${errorKey}.step1`
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `error.${errorKey}.step2`
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `error.${errorKey}.step3`
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `error.${errorKey}.step4`
        })]
      })]
    });
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    handleButtonClick: onClick,
    hasImage: false,
    linkToHelpResources: true,
    renderContent: renderContent
  });
};

export default PendingEmailOAuthError;